import axios from "axios";
import api from "../../components/commonComponents/axiosSetup";
import { BASE_URL } from "../../config";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// Fetch current month billing data
export const fetchCurrentBilling = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/billing/current`);
    return response.data;
  } catch (error) {
    console.error("Error fetching current billing:", error);
    throw error;
  }
};

// Fetch billing data for a specific month
export const fetchBillingByMonth = async (month, year) => {
  try {
    const response = await api.get(`${BASE_URL}api/billing/monthly?month=${month}&year=${year}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching billing for ${month}/${year}:`, error);
    throw error;
  }
};

// Fetch all billing data (current + previous months) in one call
export const fetchAllBillingData = async () => {
  try {
    const response = await api.get(`http://192.168.30.33:8081/apis/plans`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all billing data:", error);
    throw error;
  }
};

// ============================================
// MOCK DATA - Remove this when API is ready
// ============================================
export const getMockBillingData = () => {
  return {
    currentMonth: "December 2025",
    currentBilling: {
      airtel: [
        { planName: "RS.45 Monthly Plan", totalSims: 250, monthlyBill: 11250 },
        { planName: "RS.35 Monthly Plan", totalSims: 400, monthlyBill: 28000 },
        { planName: "Premium Plan", totalSims: 350, monthlyBill: 45500 },
      ],
      bsnl: [
        { planName: "Economy Plan", totalSims: 300, monthlyBill: 12000 },
        { planName: "Business Plan", totalSims: 450, monthlyBill: 31500 },
        { planName: "Enterprise Plan", totalSims: 250, monthlyBill: 27500 },
      ],
    },
    previousBills: {
      "November 2025": {
        airtel: [
          { planName: "RS.45 Monthly Plan", totalSims: 230, monthlyBill: 10350 },
          { planName: "RS.35 Monthly Plan", totalSims: 380, monthlyBill: 26600 },
          { planName: "Premium Plan", totalSims: 320, monthlyBill: 41600 },
        ],
        bsnl: [
          { planName: "Economy Plan", totalSims: 280, monthlyBill: 11200 },
          { planName: "Business Plan", totalSims: 420, monthlyBill: 29400 },
          { planName: "Enterprise Plan", totalSims: 230, monthlyBill: 25300 },
        ],
      },
      "October 2025": {
        airtel: [
          { planName: "RS.45 Monthly Plan", totalSims: 210, monthlyBill: 9450 },
          { planName: "RS.35 Monthly Plan", totalSims: 350, monthlyBill: 24500 },
          { planName: "Premium Plan", totalSims: 300, monthlyBill: 39000 },
        ],
        bsnl: [
          { planName: "Economy Plan", totalSims: 260, monthlyBill: 10400 },
          { planName: "Business Plan", totalSims: 400, monthlyBill: 28000 },
          { planName: "Enterprise Plan", totalSims: 210, monthlyBill: 23100 },
        ],
      },
      "September 2025": {
        airtel: [
          { planName: "RS.45 Monthly Plan", totalSims: 200, monthlyBill: 9000 },
          { planName: "RS.35 Monthly Plan", totalSims: 320, monthlyBill: 22400 },
          { planName: "Premium Plan", totalSims: 280, monthlyBill: 36400 },
        ],
        bsnl: [
          { planName: "Economy Plan", totalSims: 240, monthlyBill: 9600 },
          { planName: "Business Plan", totalSims: 380, monthlyBill: 26600 },
          { planName: "Enterprise Plan", totalSims: 200, monthlyBill: 22000 },
        ],
      },
      "August 2025": {
        airtel: [
          { planName: "RS.45 Monthly Plan", totalSims: 180, monthlyBill: 8100 },
          { planName: "RS.35 Monthly Plan", totalSims: 300, monthlyBill: 21000 },
          { planName: "Premium Plan", totalSims: 260, monthlyBill: 33800 },
        ],
        bsnl: [
          { planName: "Economy Plan", totalSims: 220, monthlyBill: 8800 },
          { planName: "Business Plan", totalSims: 360, monthlyBill: 25200 },
          { planName: "Enterprise Plan", totalSims: 180, monthlyBill: 19800 },
        ],
      },
      "July 2025": {
        airtel: [
          { planName: "RS.45 Monthly Plan", totalSims: 160, monthlyBill: 7200 },
          { planName: "RS.35 Monthly Plan", totalSims: 280, monthlyBill: 19600 },
          { planName: "Premium Plan", totalSims: 240, monthlyBill: 31200 },
        ],
        bsnl: [
          { planName: "Economy Plan", totalSims: 200, monthlyBill: 8000 },
          { planName: "Business Plan", totalSims: 340, monthlyBill: 23800 },
          { planName: "Enterprise Plan", totalSims: 160, monthlyBill: 17600 },
        ],
      },
      "June 2025": {
        airtel: [
          { planName: "RS.45 Monthly Plan", totalSims: 150, monthlyBill: 6750 },
          { planName: "RS.35 Monthly Plan", totalSims: 260, monthlyBill: 18200 },
          { planName: "Premium Plan", totalSims: 220, monthlyBill: 28600 },
        ],
        bsnl: [
          { planName: "Economy Plan", totalSims: 180, monthlyBill: 7200 },
          { planName: "Business Plan", totalSims: 320, monthlyBill: 22400 },
          { planName: "Enterprise Plan", totalSims: 150, monthlyBill: 16500 },
        ],
      },
    },
  };
};